import { render, staticRenderFns } from "./manufacturers.vue?vue&type=template&id=ea897aca&scoped=true"
import script from "./manufacturers.vue?vue&type=script&lang=js"
export * from "./manufacturers.vue?vue&type=script&lang=js"
import style0 from "./manufacturers.vue?vue&type=style&index=0&id=ea897aca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea897aca",
  null
  
)

export default component.exports